<template>
    <a href="#" v-if="session.scheduler && !session.showScheduler" @click="show()" class="btn-group pull-right">
    {{ session.scheduler.type.name }} <icon name="external-link" />
    </a>
</template>

<script>

    export default {
        name: "schedulerShortcut",
        props: ["session"],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            show() {
                this.session.showScheduler = true;
            }
        },
        watch: {
        },
        components: {
        },
        computed: {
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// SchedulerShortcut.vue?02b8e432